import { HubConnection } from '@microsoft/signalr';

export interface PrestigeStatus {
  prestigeLevel: number;
  currentPrestigeScore: number;
  totalScoreAllTime: number;
  prestigeThreshold: number;
  canPrestige: boolean;
}

export interface PrestigeResult {
  newPrestigeLevel: number;
  previousPrestigeScore: number;
  totalScoreAllTime: number;
  selectedUpgradeId: string;
  selectedUpgradeName: string;
}

export interface PrestigeUpgrade {
  id: string;
  name: string;
  description: string;
  branchType: string;
  level: number;
  bonusValue: number;
  isUnlocked?: boolean;
  isMaxLevel?: boolean;
}

export interface PrestigeUpgradeOptions {
  availableUpgrades: PrestigeUpgrade[];
}

/**
 * Get the current prestige status for a player
 */
export async function getPrestigeStatus(connection: HubConnection, playerId: string): Promise<PrestigeStatus> {
  return await connection.invoke('GetPrestigeStatus', playerId);
}

/**
 * Get available prestige upgrades for a player
 */
export async function getPrestigeUpgrades(connection: HubConnection, playerId: string): Promise<PrestigeUpgradeOptions> {
  return await connection.invoke('GetPrestigeUpgrades', playerId);
}

/**
 * Perform a prestige for a player
 */
export async function performPrestige(connection: HubConnection, playerId: string, mothershipUpgradeId: string): Promise<PrestigeResult> {
  return await connection.invoke('PerformPrestige', playerId, mothershipUpgradeId);
}
